import * as React from "react";
import {
  Show,
  TextField,
  ShowProps,
  useRecordContext,
  DateField,
  RichTextField,
  SimpleShowLayout,
} from "react-admin";

const InterviewTitle = () => {
  const record = useRecordContext();
  if (!record) return null;
  return (
    <>
      Postulante {record?.application?.applicant?.user?.fullName} - Oferta{" "}
      {record?.application?.offer?.title}
    </>
  );
};

export const ViewInterview: React.FC<ShowProps> = (props) => {
  return (
    <Show {...props} title={<InterviewTitle />}>
      <SimpleShowLayout>
        <TextField source="application.offer.title" label="Oferta" />
        <TextField
          source="application.applicant.user.fullName"
          label="Postulante"
        />
        <DateField source="interviewDate" label="Fecha de entrevista" />
        <TextField source="interviewer.fullName" label="Entrevistador" />
        <RichTextField source="comment" label="Notas" />
      </SimpleShowLayout>
    </Show>
  );
};
